import { configureStore } from "@reduxjs/toolkit";
import usersReducer from "./slices/userSlice";
import authReducer from "./slices/authSlice";
import simCardsReducer from "./slices/simCardSlice";
import imsiMapsReducer from "./slices/imsiMapSlice";
import numbersReducer from "./slices/numberSlice";
import dashboardReducer from "./slices/dashboardSlice";
import esimOrdersReducer from "./slices/esimOrderSlice";
import consumptionReducer from "./slices/consumptionSlice";
import pushReducer from "./slices/pushSlice";
import offerNumbersReducer from "./slices/offerNumberSlice";
import brandReducer from "./slices/brandSlice";
import brandSwitcherReducer from "./slices/brandSwitcherSlice";

export const store = configureStore({
  reducer: {
    users: usersReducer,
    auth: authReducer,
    simCards: simCardsReducer,
    imsiMaps: imsiMapsReducer,
    numbers: numbersReducer,
    dashboard: dashboardReducer,
    esimOrders: esimOrdersReducer,
    consumption: consumptionReducer,
    push: pushReducer,
    offerNumbers: offerNumbersReducer,
    brand: brandReducer,
    brandSwitcher: brandSwitcherReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
